import { Component } from '@theme/component';

class UserCasesModal extends Component {
  requiredRefs = [
    'modal',
    'backdrop',
    'modalContent',
    'previousButton',
    'nextButton',
    'previousPosition',
    'nextPosition',
    'storiesData',
  ];

  connectedCallback() {
    super.connectedCallback();

    this.currentIndex = 0;
    this.stories = JSON.parse(this.refs.storiesData.textContent);
    this.linkedinIconUrl = this.dataset.linkedinIconUrl || '';

    this.updateNavigationButtons();

    // Set up click handlers for story buttons
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-story-index]');
      if (button) {
        event.preventDefault();
        this.openStory(event);
      }
    });

    // Close modal when clicking backdrop
    this.refs.backdrop.addEventListener('click', () => {
      this.closeModal();
    });

    // Close modal when pressing Escape key
    this.handleEscape = (event) => {
      if (event.key === 'Escape' && this.classList.contains('is-open')) {
        this.closeModal();
      }
    };
    document.addEventListener('keydown', this.handleEscape);
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.handleEscape);
  }

  openStory(event) {
    const button = event.target.closest('[data-story-index]');
    if (!button) return;

    this.currentIndex = parseInt(button.dataset.storyIndex, 10);
    this.renderStoryContent();
    this.updateNavigationButtons();
    this.showModal();
  }

  showModal() {
    this.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  closeModal() {
    this.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  previousStory() {
    // Loop to last story if at first story
    this.currentIndex = this.currentIndex === 0
      ? this.stories.length - 1
      : this.currentIndex - 1;
    this.renderStoryContent();
    this.updateNavigationButtons();
  }

  nextStory() {
    // Loop to first story if at last story
    this.currentIndex = this.currentIndex === this.stories.length - 1
      ? 0
      : this.currentIndex + 1;
    this.renderStoryContent();
    this.updateNavigationButtons();
  }

  renderStoryContent() {
    const story = this.stories[this.currentIndex];
    if (!story) return;

    const { modalContent } = this.refs;
    const hasLinkedIn = story.linkedinUrl && story.linkedinUrl !== '';

    let html = '<div class="user-cases-modal__header">';

    // Person image
    if (story.personImage) {
      html += `<img src="${story.personImage}" alt="${story.personName || ''}" class="user-cases-modal__person-image">`;
    }

    // Person info (name + position)
    html += '<div class="user-cases-modal__info">';

    if (hasLinkedIn) {
      html += `<a href="${story.linkedinUrl}" target="_blank" rel="noopener noreferrer" class="user-cases-modal__header-link">`;

      if (story.personName) {
        html += `
          <h2 class="user-cases-modal__name">
            ${story.personName}
            <span class="user-case-card__linkedin-icon">
              <img src="${this.linkedinIconUrl}" alt="LinkedIn" class="user-case-card__linkedin-svg" width="20" height="20">
            </span>
          </h2>
        `;
      }

      if (story.position) {
        html += `<p class="user-cases-modal__position">${story.position}</p>`;
      }

      html += `</a>`;
    } else {
      if (story.personName) {
        html += `<h2 class="user-cases-modal__name">${story.personName}</h2>`;
      }

      if (story.position) {
        html += `<p class="user-cases-modal__position">${story.position}</p>`;
      }
    }

    html += '</div>'; // Close user-cases-modal__info
    html += '</div>'; // Close user-cases-modal__header

    // Description
    if (story.longDescription) {
      html += `<div class="user-cases-modal__description">${story.longDescription}</div>`;
    }

    modalContent.innerHTML = html;
  }

  updateNavigationButtons() {
    const { previousButton, nextButton, previousPosition, nextPosition } = this.refs;

    // Always enable buttons for circular navigation
    previousButton.disabled = false;
    nextButton.disabled = false;

    // Update position text for previous story (with wrapping)
    const prevIndex = this.currentIndex === 0
      ? this.stories.length - 1
      : this.currentIndex - 1;
    const prevStory = this.stories[prevIndex];
    previousPosition.textContent = prevStory?.position || '';

    // Update position text for next story (with wrapping)
    const nextIndex = this.currentIndex === this.stories.length - 1
      ? 0
      : this.currentIndex + 1;
    const nextStory = this.stories[nextIndex];
    nextPosition.textContent = nextStory?.position || '';
  }
}

if (!customElements.get('user-cases-modal')) {
  customElements.define('user-cases-modal', UserCasesModal);
}
